module.exports = __webpack_public_path__ + "img/unibud24070.abfb9a79.jpg";